import { Button, Text } from "@flixbus/honeycomb-react";
import React from "react";
import { FormattedMessage } from "react-intl";
import * as css from "./NoArticlesFoundMessage.scss";

const NoArticlesFoundMessage = () => {
  return (
    <div className={css.noResultsWrapper}>
      <Text extraClasses={css.results}>
        <FormattedMessage id="faq.search.noResults" values={{ br: <br /> }} />
      </Text>
      <Button appearance="secondary" href="mailto:cooperation-lines@flixbus.com" Elem="a">
        <FormattedMessage id="faq.search.button.contactSupport" />
      </Button>
    </div>
  );
};

export default NoArticlesFoundMessage;
